<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profileparameter.values')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileParameterSetValueForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileParameterSetValueForm from '../../components/profileparametersetvalue/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileParameterSetValue';

const { mapFields } = createHelpers({
  getterType: 'profileparametersetvalue/getField',
  mutationType: 'profileparametersetvalue/updateField'
});

export default {
  name: 'ProfileParameterSetValueCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileParameterSetValueForm
  },
  data() {
    return {
      item: {
        'profileParameterSet' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profileparametersetvalue', ['create', 'reset'])
  }
};
</script>
